import { X } from 'lucide-react'
import { chip, label as labelClass, removeButton } from './Chip.css'

export type ChipProps = {
  label: string
  onRemove?: () => void
}

export function Chip({ label, onRemove }: ChipProps) {
  return (
    <span className={chip}>
      <span className={labelClass}>{label}</span>
      {onRemove ? (
        <button
          type="button"
          className={removeButton}
          aria-label={`Remover ${label}`}
          onClick={onRemove}
        >
          <X size={13} aria-hidden />
        </button>
      ) : null}
    </span>
  )
}
